import { useLayoutEffect, useRef, useState } from "react";

const useHasBecomeVisible = () => {
  const lazyElementRef = useRef();
  const [hasBecomeVisible, setHasBecomeVisible] = useState(false);

  useLayoutEffect(
    () => {
      if (!hasBecomeVisible) {
        const onScroll = () => {
          const { top, bottom } = lazyElementRef.current.getBoundingClientRect();

          return setHasBecomeVisible(current => (
            current || (top < window.innerHeight && bottom > 0)
          ));
        };

        onScroll();

        document.addEventListener("scroll", onScroll);
        return () => document.removeEventListener("scroll", onScroll);
      }

      return undefined;
    },
    [lazyElementRef, hasBecomeVisible, setHasBecomeVisible]
  );

  return [lazyElementRef, hasBecomeVisible];
};

export default useHasBecomeVisible;
